import * as React from 'react';

export interface ITopMenuLinkDivProps {
  name: string;
  title: string;
  menuHoverLineView: React.ReactElement;
}

export const TopMenuLinkDiv = (props: ITopMenuLinkDivProps) => {
  const { name, title, menuHoverLineView } = props;

  return (
    <div data-ref={name} className="c-header-link">
      {title}
      {menuHoverLineView}
    </div>
  );
};
